import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleReset = () => {
    onReset();
    setIsOpen(false);
  };

  const activeFiltersCount = Object.values(filters).filter(
    value => value !== '' && value !== null && value !== undefined && 
    (Array.isArray(value) ? value.length > 0 : true)
  ).length;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-gray-800">{t('marketplace.filter')}</h3>
          {activeFiltersCount > 0 && (
            <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full">
              {activeFiltersCount}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {activeFiltersCount > 0 && (
            <button
              onClick={handleReset}
              className="text-sm text-gray-600 hover:text-gray-800"
            >
              {t('marketplace.clearAll')}
            </button>
          )}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-sm text-gray-600 hover:text-gray-800"
          >
            {isOpen ? t('marketplace.hide') : t('marketplace.show')}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Price Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t('marketplace.price')}
            </label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                placeholder={t('marketplace.minPrice')}
                value={filters.minPrice || ''}
                onChange={(e) => handleFilterChange('minPrice', e.target.value ? Number(e.target.value) : '')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                min="0"
              />
              <span className="text-gray-500">-</span>
              <input
                type="number"
                placeholder={t('marketplace.maxPrice')}
                value={filters.maxPrice || ''}
                onChange={(e) => handleFilterChange('maxPrice', e.target.value ? Number(e.target.value) : '')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                min="0"
              />
            </div>
          </div>

          {/* Rating Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t('marketplace.rating')}
            </label>
            <select
              value={filters.minRating || ''}
              onChange={(e) => handleFilterChange('minRating', e.target.value ? Number(e.target.value) : '')}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              <option value="">{t('common.all')}</option>
              <option value="4.5">4.5 ⭐ {t('marketplace.ratingUp')}</option>
              <option value="4.0">4.0 ⭐ {t('marketplace.ratingUp')}</option>
              <option value="3.5">3.5 ⭐ {t('marketplace.ratingUp')}</option>
              <option value="3.0">3.0 ⭐ {t('marketplace.ratingUp')}</option>
            </select>
          </div>

          {/* Store Level Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t('marketplace.storeLevel')}
            </label>
            <select
              value={filters.storeLevel || ''}
              onChange={(e) => handleFilterChange('storeLevel', e.target.value || '')}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              <option value="">{t('common.all')}</option>
              <option value="diamond">Diamond</option>
              <option value="platinum">Platinum</option>
              <option value="gold">Gold</option>
              <option value="silver">Silver</option>
              <option value="bronze">Bronze</option>
            </select>
          </div>

          {/* Sort By */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {t('marketplace.sortBy')}
            </label>
            <select
              value={filters.sortBy || 'newest'}
              onChange={(e) => handleFilterChange('sortBy', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
            >
              <option value="newest">{t('marketplace.sortNewest')}</option>
              <option value="oldest">{t('marketplace.sortOldest')}</option>
              <option value="priceLow">{t('marketplace.sortPriceLow')}</option>
              <option value="priceHigh">{t('marketplace.sortPriceHigh')}</option>
              <option value="rating">{t('marketplace.sortRating')}</option>
              <option value="popular">{t('marketplace.sortPopular')}</option>
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;








